// Header.jsx
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faYoutube, faFacebook, faInstagram, faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";
import DirectorioModal from "../components/Directorio/DirectorioModal";
import { HEADER_STYLE } from "../config/headerStyle";
import "../styles/header/opcion4-moderno-editorial.css";
// Imagen de fachada recortada actualizada
import headerFoto from "../assets/header-ITE.png";

export default function Header() {
  const [directorioOpen, setDirectorioOpen] = useState(false);

  return (
    <div className="hdr-op4-top-container" data-header-style={HEADER_STYLE}>
      {/* ====== 1. Banner Principal Desktop (>=992px) ====== */}
      <div className="hdr-op4-main-banner">
        {/* Bloque Izquierdo: Redes + Logo + Línea + Texto */}
        <div className="hdr-op4-left-block">
          {/* Columna Vertical de Redes Sociales (Costado Izquierdo) */}
          <div className="hdr-op4-social-col-wrapper">
            <div className="hdr-op4-social-column" aria-label="Redes sociales institucionales">
              <button
                type="button"
                className="hdr-op4-social-btn"
                title="Directorio general"
                aria-label="Directorio general"
                onClick={() => setDirectorioOpen(true)}
              >
                <div className="hdr-op4-social-circle">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="4 4 13 15"
                    fill="currentColor"
                    width="13"
                    height="13"
                  >
                    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55-.45-1-1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                  </svg>
                </div>
              </button>

              <a
                href="https://www.youtube.com/channel/UCUBfUX_c54NfhhvZRzK0k1w"
                target="_blank"
                rel="noreferrer"
                className="hdr-op4-social-btn"
                title="YouTube"
                aria-label="YouTube"
              >
                <div className="hdr-op4-social-circle">
                  <FontAwesomeIcon icon={faYoutube} />
                </div>
              </a>

              <a
                href="https://twitter.com/ITETLAX"
                target="_blank"
                rel="noreferrer"
                className="hdr-op4-social-btn"
                title="X (Twitter)"
                aria-label="X (Twitter)"
              >
                <div className="hdr-op4-social-circle">
                  <FontAwesomeIcon icon={faXTwitter} />
                </div>
              </a>

              <a
                href="https://es-la.facebook.com/InstitutoTlaxcaltecadeElecciones/"
                target="_blank"
                rel="noreferrer"
                className="hdr-op4-social-btn"
                title="Facebook"
                aria-label="Facebook"
              >
                <div className="hdr-op4-social-circle">
                  <FontAwesomeIcon icon={faFacebook} />
                </div>
              </a>

              <a
                href="https://www.instagram.com/ite_tlaxcala"
                target="_blank"
                rel="noreferrer"
                className="hdr-op4-social-btn"
                title="Instagram"
                aria-label="Instagram"
              >
                <div className="hdr-op4-social-circle">
                  <FontAwesomeIcon icon={faInstagram} />
                </div>
              </a>
            </div>

            {/* Línea vertical delgada magenta de separación */}
            <div className="hdr-op4-social-divider" aria-hidden="true"></div>
          </div>

          {/* ====== 2. Zona del Logo / Branding ====== */}
          <div className="hdr-op4-brand-container">
            <Link to="/" className="hdr-op4-logo-link">
              <img
                src="https://itetlax.org.mx/assets/img/logoite.webp"
                alt="Instituto Tlaxcalteca de Elecciones"
                className="hdr-op4-logo img-fluid"
              />
            </Link>

            <div className="hdr-op4-divider"></div>

            <div className="hdr-op4-title-group">
              <div className="hdr-op4-title-line1">
                Instituto <strong className="hdr-op4-highlight">Tlaxcalteca</strong>
              </div>
              <div className="hdr-op4-title-line2">de Elecciones</div>
            </div>
          </div>
        </div>

        {/* Franjas diagonales y recorte de foto del edificio */}
        <div className="hdr-op4-diagonal-wrapper" aria-hidden="true">
          {/* 1. Banda magenta dividida en dos mitades (50% / 50%) */}
          <div className="hdr-op4-banda">
            <div className="hdr-op4-banda-mitad-1"></div>
            <div className="hdr-op4-banda-mitad-2"></div>
          </div>
          {/* 2. Línea blanca separadora */}
          <div className="hdr-op4-linea-separadora"></div>
          {/* 3. Recorte de foto del edificio con overlay rosa */}
          <div className="hdr-op4-building-crop">
            <img
              src={headerFoto}
              alt="Sede del Instituto Tlaxcalteca de Elecciones"
              className="hdr-op4-building-img"
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          </div>
        </div>
      </div>

      {/* ====== 3. Banner Principal Mobile (Propuesta 1) ====== */}
      <div className="hdr-op4-mobile-hero">
        {/* Fotografía de fondo del edificio del ITE */}
        <div className="hdr-op4-mob-bg-container">
          <img
            src={headerFoto}
            alt="Sede del Instituto Tlaxcalteca de Elecciones"
            className="hdr-op4-mob-building-img"
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
          {/* Degradado moderno integrado (morado oscuro / fucsia / magenta) */}
          <div className="hdr-op4-mob-gradient-overlay" aria-hidden="true"></div>
        </div>

        {/* Formas diagonales modernas (fucsia / magenta / morado / rosa) */}
        <div className="hdr-op4-mob-diagonals" aria-hidden="true">
          <div className="hdr-op4-mob-diag-band-1"></div>
          <div className="hdr-op4-mob-diag-band-2"></div>
          <div className="hdr-op4-mob-diag-accent"></div>
        </div>

        {/* Composición tipográfica institucional del banner */}
        <div className="hdr-op4-mob-content">
          <div className="hdr-op4-mob-title-group">
            <span className="hdr-op4-mob-line-white">Instituto</span>
            <span className="hdr-op4-mob-line-fuchsia">Tlaxcalteca</span>
            <span className="hdr-op4-mob-line-white">de Elecciones</span>
          </div>

          <div className="hdr-op4-mob-divider-line" aria-hidden="true"></div>
        </div>
      </div>

      <DirectorioModal
        isOpen={directorioOpen}
        onClose={() => setDirectorioOpen(false)}
      />
    </div>
  );
}
